import { CoProduct } from '@mews/std';

export enum TaxRateStrategyDiscriminator {
    Dependent = 'Dependent',
    Flat = 'Flat',
    Relative = 'Relative',
}

export interface RelativeTaxRateStrategy {
    value: number;
}

export interface FlatTaxRateStrategy {
    currencyCode: string;
    value: number;
}

export interface DependentTaxRateStrategy {
    baseTaxationCodes: string[];
    value: number;
}

export type RelativeTaxRateStrategyCoProduct = CoProduct<
    TaxRateStrategyDiscriminator.Relative,
    RelativeTaxRateStrategy
>;
export type FlatTaxRateStrategyCoProduct = CoProduct<TaxRateStrategyDiscriminator.Flat, FlatTaxRateStrategy>;
export type DependentTaxRateStrategyCoProduct = CoProduct<
    TaxRateStrategyDiscriminator.Dependent,
    DependentTaxRateStrategy
>;

export type TaxRateStrategyCoProduct =
    | RelativeTaxRateStrategyCoProduct
    | FlatTaxRateStrategyCoProduct
    | DependentTaxRateStrategyCoProduct;

export interface TaxRate {
    code: string;
    /** @deprecated use TaxRate.strategy.value instead */
    value: number;
    strategy: TaxRateStrategyCoProduct;
}

export interface Taxation {
    code: string;
    name: string;
    localName: string;
    taxRates: Array<TaxRate>;
}

export const isFlatTaxRateStrategy = (strategy: TaxRateStrategyCoProduct): strategy is FlatTaxRateStrategyCoProduct =>
    strategy.discriminator === TaxRateStrategyDiscriminator.Flat;
